// @ts-check

/**
 * Function to validate password.
 * @param {String} password Password to be validated
 * @returns Empty string if validation passes, error message if validation failed
 */
const validatePassword = (password) => {
  if (!password) {
    return "validation.passwordRequired";
  }

  // Check minimum length
  if (password.length < 8) {
    return "validation.passwordTooShort";
  }

  // Check maximum length
  if (password.length > 128) {
    return "validation.passwordTooLong";
  }

  // Check for at least one uppercase letter
  if (!/[A-Z]/.test(password)) {
    return "validation.passwordNeedsAnUppercase";
  }

  // Check for at least one lowercase letter
  if (!/[a-z]/.test(password)) {
    return "validation.passwordNeedsALowercase";
  }

  // Check for at least one number
  if (!/[0-9]/.test(password)) {
    return "validation.passwordNeedsANumber";
  }

  // Check for at least one special character
  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
    return "validation.passwordNeedsASpecialCharacter";
  }

  // Check for no whitespace
  if (/\s/.test(password)) {
    return "validation.passwordCannotHaveSpaces";
  }

  // Check for common weak patterns
  const commonPatterns = [
    /(.)\1{2,}/, // Three or more consecutive identical characters
    /123456|654321|abcdef|qwerty/i, // Common sequences
  ];

  for (const pattern of commonPatterns) {
    if (pattern.test(password)) {
      return "validation.passwordIsTooCommon";
    }
  }

  return "";
};

module.exports = {
  validatePassword
};